module.exports = __webpack_public_path__ + "img/slider-icon.2b168a8a.png";